import * as _ from "lodash"
import * as React from "react"

const floatRegex = new RegExp("^\\d*(\\.\\d*)?$")

export interface IMaterialInputProps
    extends React.DetailedHTMLProps<
        React.InputHTMLAttributes<HTMLInputElement>,
        HTMLInputElement
    > {
    disableMaterialPlaceholder?: boolean
    floatMode?: boolean
    numberMode?: boolean
    formattedNumberMode?: boolean
    showValidityErrors?: boolean
    trim?: boolean
    forceRemoveValue?: boolean
}

export interface IMaterialInputState {
    hasValue: boolean
    hasFocus: boolean
}

export class MaterialInput extends React.Component<
    IMaterialInputProps,
    IMaterialInputState
> {
    state = {
        hasFocus: false,
        hasValue: false,
    }

    private inputElement: HTMLInputElement
    private lastValue: string | number

    componentWillMount() {
        const hasValue =
            !_.isNil(this.props.defaultValue) || !_.isNil(this.props.value)
                ? true
                : false
        this.lastValue = this.props.value as string

        this.setState({ hasValue })
    }

    componentDidMount() {
        if (this.props.autoFocus) {
            this.focus()
        }
    }

    onChange(e: React.ChangeEvent<HTMLInputElement>): void {
        let value: string | number = e.currentTarget.value
        const hasValue = !!value
        // tslint:disable-next-line:no-console
        //console.log('number input: ' + JSON.stringify(value) + ' and is requred: ' + this.props.required + ' validity: ' + this.inputElement.checkValidity())

        if (this.props.type === "number" || this.props.numberMode) {
            if (value && typeof value === "string") {
                value = value.replace(/\D/g, "")
            }
        }

        if (this.props.floatMode) {
            if (value && typeof value === "string") {
                const valueOK = value.match(floatRegex)
                // tslint:disable-next-line:no-console
                //console.log('test of: ' + value + ' yields: ' + valueOK)
                if (!valueOK) {
                    value = this.lastValue as string
                }
            }
        }

        if (this.props.trim) {
            value = value.trim()
        }

        //re-assign value
        e.target.value = value

        if (this.lastValue !== value) {
            this.setState({ hasValue })

            if (typeof this.props.onChange === "function") {
                // tslint:disable-next-line:no-console
                //console.log('MaterialInput- onChange with ' + e.target.value)
                this.props.onChange(e)
            }

            this.lastValue = value
        }
    }

    onFocusChange(e: React.FocusEvent<HTMLInputElement>, hasFocus: boolean) {
        this.setState({ hasFocus })
        if (hasFocus) {
            if (typeof this.props.onFocus === "function") {
                this.props.onFocus(e)
            }
        } else if (typeof this.props.onBlur === "function") {
            this.props.onBlur(e)
        }
    }

    focus() {
        this.setState({ hasFocus: true }, () => {
            this.inputElement.focus()

            if (this.inputElement.value) {
                this.inputElement.selectionStart =
                    this.inputElement.value.length
            }
        })
    }

    getClasses() {
        let classes = "material-input-group"

        if (this.state.hasValue) {
            classes += " hasValue"
        }

        if (this.state.hasFocus) {
            classes += " hasFocus"
        }

        if (this.props.disableMaterialPlaceholder) {
            classes += " disableMaterialPlaceholder"
        }

        if (this.props.showValidityErrors && this.inputElement) {
            if (!this.inputElement.checkValidity()) {
                classes += " has-error"
            }
        }

        return classes
    }

    render() {
        const { forceRemoveValue } = this.props
        const inputProps = { ...this.props }

        //remove non input props
        delete inputProps.placeholder
        delete inputProps.forceRemoveValue
        delete inputProps.numberMode
        delete inputProps.floatMode
        delete inputProps.showValidityErrors
        delete inputProps.trim
        delete inputProps.disableMaterialPlaceholder

        //Allow for consumers to set value to null
        if (inputProps.value === null || forceRemoveValue) {
            inputProps.value = ""
        }

        const v = this.props.type === "date" ? this.lastValue : this.props.value

        return (
            <div className={this.getClasses()}>
                {this.props.disableMaterialPlaceholder ? null : (
                    <label className="material-input-placeholder">
                        {this.props.placeholder}
                    </label>
                )}

                <input
                    className="form-control material-input"
                    {...inputProps}
                    value={v}
                    ref={(inputElem) => (this.inputElement = inputElem)}
                    onChange={(e) => this.onChange(e)}
                    onFocus={(e) => this.onFocusChange(e, true)}
                    onBlur={(e) => this.onFocusChange(e, false)}
                />
            </div>
        )
    }
}

export default MaterialInput



// WEBPACK FOOTER //
// ./src/app/components/material/MaterialInput/index.tsx